import axios from 'axios'

export default {
  getNotes ( params, callback ) {
    axios.get('/notes', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getNote ( noteId, callback ) {
    axios.get('/notes/' + noteId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  create ( data, callback, fallback ) {
    axios.post( '/notes', data )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined')
          fallback(error);
      });
  },
  save ( noteId, data, callback, fallback ) {
    axios.post( '/notes/' + noteId, data )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( noteId, callback, fallback ) {
    axios.delete( '/notes/' + noteId )
      .then(resp => {
        if(typeof(callback) != 'undefined')
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteMany ( noteIds, callback, fallback ) {
    axios.post( '/notes/delete', { ids: noteIds })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
}
